
import { Placement } from '@post-office/placements-frontend/jira-project-space-connected';
export default Placement;
